// What the caller may do INSIDE a project, from their role on it (`my_role`:
// "owner" | "editor" | "viewer"). The BE sends it on the project list's cards,
// on GET /insights/projects/<id>/ and on the By-group plan
// (GET /insights/reports/<id>/group-actions/).
//
// A viewer reads the project — its register, activities, evidence, documents,
// and the AI answers over them — but changes none of it: the BE refuses their
// writes with 403 `{code: "insufficient_role"}`. Owners and editors (and staff
// and org admins, who the BE reports as owners) change everything.

export const EDIT_ROLES = ["owner", "editor"];

// `undefined` means the field was never sent — a BE that predates roles, which
// let every member edit — so it allows. `null` means the caller has no role on
// the project (e.g. they reach a report directly, not through membership), and
// that does not.
export const canEditProjectContent = (role) =>
    role === undefined || EDIT_ROLES.includes(role);

// Whether an axios error is the BE's role refusal.
export const isRoleRefusal = (error) =>
    error?.response?.status === 403 &&
    error?.response?.data?.code === "insufficient_role";

// The translated sentence for a role refusal, or `null` for any other error —
// so a screen's own error handling stays in charge of everything else.
export const roleRefusalMessage = (error, intl) =>
    isRoleRefusal(error)
        ? intl.formatMessage({
              id: "projects.viewer_cannot_edit",
              defaultMessage: "You have view-only access to this project.",
          })
        : null;
